export default class ApiUrl {
  public static websiteUrl:string = "https://www.oneworldnetwork.co"
  
  //Production
  public static baseUrl: string = "https://api.oneworldnetwork.co/api";
  public static fileBaseUrl: string = "https://api.oneworldnetwork.co/media/";

  // local Rohit
  // public static baseUrl: string = "http://192.168.1.8:8083/api";
  // public static fileBaseUrl: string = "http://192.168.1.8:8083/media/";

  // local Chahek
  // public static baseUrl: string = "http://192.168.1.8:8083/api";
  // public static fileBaseUrl: string = "http://192.168.1.8:8083/media/";

  // local Testing
  // public static baseUrl: string = "http://192.168.0.17:8888/api";
  // public static fileBaseUrl: string = "http://192.168.0.17:8888/media/";

}
